import { Button, FormControlLabel, Grid, TextField } from "@mui/material";
import Switch from "@mui/material/Switch";

// import { formats, products, datumValues, regions } from "./constants";
import { DateRangePicker } from "../share-component/data-range-picker";
import { MultiSelectFormControl } from "../share-component/multi-select";
import { toTitleCase } from "utils/commons";
import { ProductDefinition } from "data/models";

export function DatasetFilters({
  values,
  handleChange,
  handleSubmit,
  definitions,
  time,
  setTime,
  setFieldValue,
  setQueryFilterState,
  resetForm,
  presetRange,
  setPresetRange,
  initialQueryFilterState,
  queryFilterState,
  localStorageKey,
}: any) {
  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          id="query"
          name="query"
          label="Search"
          type="text"
          size="small"
          value={values.query}
          onChange={(e: any) => {
            handleChange(e);
            handleSubmit();
          }}
          variant={"outlined"}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MultiSelectFormControl
          id={"product"}
          label={"Product"}
          options={definitions.isSuccess ? [...definitions.data.products].sort((a, b) => a.displayName.localeCompare(b.displayName)) : []}
          getOptionLabel={(s: ProductDefinition) => toTitleCase(s.displayName)}
          value={values.product}
          handleSubmit={handleSubmit}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MultiSelectFormControl
          id={"region"}
          label={"Region"}
          options={definitions.isSuccess ? definitions.data.regions : []}
          value={values.region}
          handleSubmit={handleSubmit}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MultiSelectFormControl
          id={"format"}
          label={"Format"}
          options={definitions.isSuccess ? definitions.data.formats : []}
          value={values.format}
          handleSubmit={handleSubmit}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MultiSelectFormControl
          id={"datum"}
          label={"Datum"}
          options={definitions.isSuccess ? definitions.data.datums : []}
          value={values.datum}
          handleSubmit={handleSubmit}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        md={3}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <DateRangePicker
          time={time}
          setTime={setTime}
          setFieldValue={setFieldValue}
          handleSubmit={handleSubmit}
          presetRange={presetRange}
          setPresetRange={setPresetRange}
          disabled={values.latestRelease}
          queryFilterState={queryFilterState}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm="auto"
        md="auto"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={values.latestRelease}
              onChange={(e: any) => {
                handleChange(e);
                handleSubmit();
              }}
              id="latestRelease"
              name="latestRelease"
            />
          }
          label="Latest Release"
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm="auto"
        md="auto"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={values.includeChildProducts}
              onChange={(e: any) => {
                handleChange(e);
                handleSubmit();
              }}
              id="includeChildProducts"
              name="includeChildProducts"
            />
          }
          label="Insight Pack"
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm="auto"
        md="auto"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={values.licenced}
              onChange={(e: any) => {
                handleChange(e);
                handleSubmit();
              }}
              id="licenced"
              name="licenced"
            />
          }
          label="Licenced"
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm="auto"
        md="auto"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <Button
          variant="text"
          size="small"
          color="info"
          id="clearFilters"
          name="clearFilters"
          onClick={() => {
            setTime({ startTime: 0, endTime: 0 });
            setFieldValue("release", "");
            localStorage.removeItem(localStorageKey);
            setQueryFilterState(initialQueryFilterState);
            resetForm();
            handleSubmit();
          }}
        >
          Clear
        </Button>
      </Grid>
    </Grid>
  );
}
